import { isProd } from '../../../utils/isProd/isProd.web';

export const getAPIHost = () => {
  if (isProd()) {
    return 'https://api.a-bly.com';
  }

  const STAG_API_HOST_KEY = 'stag-api-host';
  const stagName = new URLSearchParams(document.location.search).get('stag');
  if (stagName) {
    localStorage.setItem('stag-api-host', stagName);
  }
  return `https://${localStorage.getItem(STAG_API_HOST_KEY) ?? 'stag'}.api.a-bly.com`;
};
